import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import {
  routeDatevSettingsHome,
  routeDatevSettingsRoot,
} from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/datevSettingsRoutes.ts'
import { routeSlackRoot } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/slackRoutes.ts'
import { routeGoogleCalendarRoot } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleCalendarRoutes.ts'
import { routeGoogleSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleSettingsRoutes.ts'
import { routeWebhookRoot } from '@/routers/routes/mainRoutes/routeSettings/routeInterfaces/webhookRoutes.ts'

const routeInterfacesHome: RouteRecordRaw = routeDatevSettingsHome

const routeInterfacesRoot: RouteRecordRaw = {
  children: [
    routeDatevSettingsRoot,
    routeGoogleSettingsHome,
    routeGoogleCalendarRoot,
    routeSlackRoot,
    routeWebhookRoot,
  ],
  path: 'interfaces',
}

const redirectInterfaces: RedirectRouteRelative = {
  name: routeInterfacesHome.name,
}

export { redirectInterfaces, routeInterfacesHome, routeInterfacesRoot }
